import { render, staticRenderFns } from "./Extraportuarios.vue?vue&type=template&id=e526a29a"
import script from "./Extraportuarios.vue?vue&type=script&lang=js"
export * from "./Extraportuarios.vue?vue&type=script&lang=js"
import style0 from "./Extraportuarios.vue?vue&type=style&index=0&id=e526a29a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports